import React, {useMemo, useState} from "react";
import {useRouter} from "next/router";
import {usePanel} from "../../redux/reducer/panel";
import AppearSensor from "../baseComponents/helpers/appearSensor/AppearSensor";
import classNames from "classnames";
import Zodiacs from "../zodiacs/Zodiacs";
import AuthorInfoButton from "../authorInfo/AuthorInfoButton";
import {settings} from "../../constants/carousel-settings";
import Carousel from "../baseComponents/gui/carousel/Carousel";
import {horoscopeTab, navButtons} from "../../constants/copyright";
import {safeHTML} from "../../utils/safeHTML";
import Button from "../baseComponents/gui/button/Button";
import Prediction from "../prediction/Prediction";
import HoroscopeFaq from "../horoscopeFaq/HoroscopeFaq";
import Games from "../games/Games";
import stylesGames from "../games/Games.module.scss"

const predictionHref = '/goroskop/prediction'

import styles from "./Horoscope.module.scss";

const Horoscope = React.forwardRef(
  function Horoscope(props, ref) {
    const {data, horoscopeTitle, className, children} = props;
    const {filter} = usePanel();
    const {buttonBack, buttonToTop} = navButtons;
    const [activeZodiac, setActiveZodiac] = useState(null);
    const [activeTypeId, setActiveTypeId] = useState("today"); // yesterday, today, tomorrow, week, month, year

    const {horoscope, tabs, identifier} = data;
    const zodiacList = horoscope?.zodiacs;

    const faq = tabs?.faq || [];
    const predictions = tabs?.predictions || [];
    const isPrediction = useMemo(() => {
      return identifier === 'prediction'
    }, [identifier])

    const router = useRouter();

    const onRoute = (href) => {
      router.push(href)
    }

    const getDateTest = (ts) => {

      const date = new Date(ts * 1000).toLocaleString('ru-RU', {
        day: 'numeric',
        month: 'numeric',
        year: 'numeric',
        timeZone: 'Europe/Moscow'
      });
      const dateNow = new Date().toLocaleString('ru-RU', {
        day: 'numeric',
        month: 'numeric',
        year: 'numeric',
        timeZone: 'Europe/Moscow'
      });

      const [day, month, year] = date.split('.')
      const [dayNow, monthNow, yearNow] = dateNow.split('.')

      const dateCombine = month + day + year
      const dateCombineNow = monthNow + dayNow + yearNow

      if (+dateCombine === +dateCombineNow) return "Сегодня";
      if (+dateCombineNow > +dateCombine) return "Вчера";
      if (+dateCombineNow < +dateCombine) return "Завтра";

      return "Неопределено";
    }

    const tabList = useMemo(() => {
      const {day, month, week, year} = tabs
      const days = day
      return [...days, ...week, ...month, ...year]
    }, [horoscope, tabs])

    const nameTabs = (period, date) => {
      if (period === 'Day') {
        return getDateTest(date)
      }
      if (period === 'Week') {
        return 'Неделя'
      }
      if (period === 'Month') {
        return 'Месяц'
      }
      if (period === 'Year') {
        return 'Год'
      }
    }


    const newHoroscopeTabList = useMemo(() => {
      let arr = tabList.map((item, index) => {
        return {
          id: index + 1,
          text: nameTabs(item?.period, item?.date),
          active: horoscope?.period !== 'Day' ? horoscope?.period === item?.period : horoscope?.period === item?.period && horoscope?.date === item?.date,
          onClick: () => {
            onRoute(item?.href)
          }
        }
      });
      return arr;
    }, [horoscopeTab, activeTypeId, horoscope]);

    const horoscopeText = horoscope?.text
    const horoscopeIcon = horoscope?.zodiacSign?.image;
    const bets = horoscope?.bets;

    return (
      <section className={classNames(styles.horoscope, className, {
        [styles.horoscope_main]: !horoscope?.zodiacSign && !isPrediction,
        [styles.horoscope_prediction]: isPrediction
      })} ref={ref}>
        {newHoroscopeTabList.length ? <>
          <div className={styles.horoscope__content}>
            {(horoscope?.zodiacSign || isPrediction) &&
              <Button routerUrl={filter ? filter : '/'} {...buttonBack}/>}
            {isPrediction
              ? <Prediction list={predictions}
                            tag={"h1"}
                            className={styles.horoscope__prediction}/>
              : <>
                <h1 className={styles.horoscope__title}>
                  {horoscope?.zodiacSign && <span className={styles.horoscope__titleIcon}>
              <img src={horoscopeIcon} alt={activeZodiac}
                   width={110} height={110}
                   fetchpriority={"high"}
                   loading={"eager"}
              />
            </span>}
                  <span className={styles.horoscope__titleText}>{safeHTML(horoscopeTitle)}</span>
                </h1>
                <div className={styles.horoscope__tab}>
                  <Carousel item={AuthorInfoButton}
                            itemsData={newHoroscopeTabList}
                            settings={{...settings.authorTabs}}
                  />
                </div>
                <div className={styles.horoscope__text}>{safeHTML(horoscopeText)}</div>
              </>}

            {!!bets.length && <Games bets={bets} className={stylesGames.games_horoscope} isFetchpriorityGame={true}/>}
          </div>
          <AppearSensor partialVisibility={true}>
            {({hasBeenVisible}) =>
              <Zodiacs
                className={classNames("", {
                  "_show": hasBeenVisible
                })}
                setActiveZodiac={(e) => {
                  setActiveZodiac(e);
                }} {...data}
                list={zodiacList}/>}
          </AppearSensor></> : <div>{'Звезды молчат....'}</div>}
        {!isPrediction &&
        <Prediction list={predictions}
                    className={styles.horoscope__prediction}
                    tag={"h2"}
                    onRoute={() => {
                      onRoute(predictionHref)
                    }}
        />
        }
        {children}
        {!horoscope?.zodiacSign && !isPrediction && <HoroscopeFaq faq={faq}/>}

      </section>
    );
  });

export default Horoscope;
Horoscope.propTypes = {};

